import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

export default function PassportApplicationCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Checking your application...");
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkApplicationStatus = async () => {
      try {
        const success = searchParams.get("success");
        
        console.log("=== Callback Debug ===");
        console.log("Success param:", success);
        console.log("API URL:", process.env.REACT_APP_BACKEND_URL);
        
        if (success !== "true") {
          setStatus("Authentication failed. Redirecting...");
          setTimeout(() => navigate("/login"), 2000);
          return;
        }

        setStatus("Verifying your session...");
        
        // Check if user already has an application using existing /auth/user endpoint
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/auth/user`,
          { 
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        console.log("Auth User Response:", response.data);

        // Map /auth/user response to frontend expected format
        const { status: authStatus, applicationData } = response.data;
        
        if (response.data.success && authStatus !== "no_application") {
          const application = applicationData;
          console.log("Existing application found:", application);
          
          // Route based on authStatus or application status
          const normalizedStatus = authStatus.toLowerCase();
          
          if (normalizedStatus.includes('approved')) {
            setStatus("Application approved! Redirecting...");
            setTimeout(() => {
              navigate("/passport/status/approved", {
                state: { applicationData: application }
              });
            }, 1000);
          } else if (normalizedStatus === 'rejected') {
            setStatus("Application needs attention. Redirecting...");
            setTimeout(() => {
              navigate("/passport/status/rejected", {
                state: { 
                  applicationData: application,
                  applicationId: application?.application_number || application?.id
                }
              });
            }, 1000);
          } else if (
            normalizedStatus === 'under_renewal' || 
            normalizedStatus === 'under_verification' || 
            normalizedStatus === 'pending' || 
            normalizedStatus === 'submitted'
          ) {
            setStatus("Application is being processed. Redirecting...");
            setTimeout(() => {
              navigate("/passport/status/pending", {
                state: { applicationData: application }
              });
            }, 1000);
          } else {
            // For any other status, go to portal
            setStatus("Redirecting to portal...");
            setTimeout(() => {
              navigate("/passport/application", {
                state: { applicationData: application }
              });
            }, 1000);
          }
        } else {
          // No application, proceed to form
          console.log("No existing application. Redirecting to application form...");
          setStatus("Redirecting to application form...");
          
          setTimeout(() => {
            navigate("/passport/application");
          }, 1000);
        }
      } catch (error) {
        console.error("Error checking application:", error);
        console.error("Error response:", error.response);
        console.error("Error status:", error.response?.status);
        console.error("Error data:", error.response?.data);
        
        if (error.response?.status === 401) {
          setError("Session expired. Please login again.");
          setTimeout(() => navigate("/login"), 2000);
        } else {
          setError(error.response?.data?.message || error.message);
          setStatus("Error occurred. Redirecting to application form...");
          
          setTimeout(() => {
            navigate("/passport/application");
          }, 2000);
        }
      }
    };

    checkApplicationStatus();
  }, [navigate, searchParams]);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      backgroundColor: "#f3f4f6",
      padding: "20px"
    }}>
      <div style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "40px",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        textAlign: "center",
        maxWidth: "400px"
      }}>
        {!error ? (
          <div style={{
            width: "48px",
            height: "48px",
            border: "4px solid #e5e7eb",
            borderTop: "4px solid #1e3a8a",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px"
          }}></div>
        ) : (
          <div style={{
            width: "48px",
            height: "48px",
            backgroundColor: "#fecaca",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
            fontSize: "24px"
          }}>⚠️</div>
        )}
        
        <h2 style={{
          fontSize: "20px",
          fontWeight: "600",
          color: "#1f2937",
          marginBottom: "8px"
        }}>
          {error ? "Error Occurred" : "Processing Authentication"}
        </h2>
        
        <p style={{
          fontSize: "14px",
          color: "#6b7280",
          marginBottom: error ? "12px" : "0"
        }}>
          {status}
        </p>

        {error && (
          <p style={{
            fontSize: "12px",
            color: "#dc2626",
            backgroundColor: "#fef2f2",
            padding: "8px",
            borderRadius: "6px",
            marginTop: "12px"
          }}>
            {error}
          </p>
        )}
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}